export const PATHS = {
  ROOT: 'careers',
  getOneById: (id: number) => `${PATHS.ROOT}/${id}`,
  getAllByResumeId: (resumeId: number) => `resume/${resumeId}/${PATHS.ROOT}`,
};
